(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brick', {
            parent: 'entity',
            url: '/brick?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brick.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick/bricks.html',
                    controller: 'BrickController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brick');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brick-detail', {
            parent: 'entity',
            url: '/brick/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brick.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick/brick-detail.html',
                    controller: 'BrickDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brick');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Brick', function($stateParams, Brick) {
                    return Brick.get({id : $stateParams.id});
                }]
            }
        })
        .state('brick.new', {
            parent: 'brick',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-dialog.html',
                    controller: 'BrickDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaNo: null,
                                areaName: null,
                                territoryNo: null,
                                territoryName: null,
                                postalCode: null,
                                municipality: null,
                                microCode: null,
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('brick');
                });
            }]
        })
        .state('brick.edit', {
            parent: 'brick',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-dialog.html',
                    controller: 'BrickDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Brick', function(Brick) {
                            return Brick.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brick.delete', {
            parent: 'brick',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-delete-dialog.html',
                    controller: 'BrickDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Brick', function(Brick) {
                            return Brick.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
